export default "__VITE_ASSET__S_RhK5LR__"